import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card-container pageheader enterpriseusers" }
const _hoisted_2 = { class: "top" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "head" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "header" }, "EnterpriseAdmin Users")
], -1)
const _hoisted_4 = { class: "search toprow" }
const _hoisted_5 = { class: "p-input-icon-left field-container" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_7 = { class: "bottom" }
const _hoisted_8 = { class: "search bottomrow" }
const _hoisted_9 = { class: "p-input-icon-left field-container" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_11 = { class: "create" }
const _hoisted_12 = { class: "container flex-grow-1 maintable enterpriseusers" }
const _hoisted_13 = { class: "button-container" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { style: {"text-align":"center"} }, "No users found.", -1)
const _hoisted_15 = { class: "field" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { for: "enterprise" }, [
  /*#__PURE__*/_createTextVNode("Enterprise"),
  /*#__PURE__*/_createElementVNode("span", { class: "req" }, "*")
], -1)
const _hoisted_17 = {
  key: 0,
  class: "error"
}
const _hoisted_18 = { class: "field" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { for: "enterprise" }, [
  /*#__PURE__*/_createTextVNode("Enterprise Store"),
  /*#__PURE__*/_createElementVNode("span", { class: "req" }, "*")
], -1)
const _hoisted_20 = {
  key: 0,
  class: "error"
}
const _hoisted_21 = { class: "field" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, [
  /*#__PURE__*/_createTextVNode("Name"),
  /*#__PURE__*/_createElementVNode("span", { class: "req" }, "*")
], -1)
const _hoisted_23 = {
  key: 0,
  class: "error"
}
const _hoisted_24 = { class: "field" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { for: "email" }, [
  /*#__PURE__*/_createTextVNode("Email"),
  /*#__PURE__*/_createElementVNode("span", { class: "req" }, "*")
], -1)
const _hoisted_26 = {
  key: 0,
  class: "error"
}
const _hoisted_27 = { class: "field" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", { for: "password" }, [
  /*#__PURE__*/_createTextVNode("Password"),
  /*#__PURE__*/_createElementVNode("span", { class: "req" }, "*")
], -1)
const _hoisted_29 = {
  key: 0,
  class: "error"
}
const _hoisted_30 = { class: "field" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", { for: "confirmpassword" }, [
  /*#__PURE__*/_createTextVNode("Confirm password"),
  /*#__PURE__*/_createElementVNode("span", { class: "req" }, "*")
], -1)
const _hoisted_32 = {
  key: 0,
  class: "error"
}
const _hoisted_33 = { class: "field" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Blocked"),
  /*#__PURE__*/_createElementVNode("span", { class: "req" }, "*")
], -1)
const _hoisted_35 = { class: "formgrid grid" }
const _hoisted_36 = { class: "field-radiobutton col-12" }
const _hoisted_37 = { for: "status" }
const _hoisted_38 = { class: "field" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", { for: "enterprise" }, [
  /*#__PURE__*/_createTextVNode("Enterprise"),
  /*#__PURE__*/_createElementVNode("span", { class: "req" }, "*")
], -1)
const _hoisted_40 = {
  key: 0,
  class: "error"
}
const _hoisted_41 = { class: "field" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("label", { for: "enterprise" }, [
  /*#__PURE__*/_createTextVNode("Enterprise Store"),
  /*#__PURE__*/_createElementVNode("span", { class: "req" }, "*")
], -1)
const _hoisted_43 = {
  key: 0,
  class: "error"
}
const _hoisted_44 = { class: "field" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, [
  /*#__PURE__*/_createTextVNode("Name"),
  /*#__PURE__*/_createElementVNode("span", { class: "req" }, "*")
], -1)
const _hoisted_46 = {
  key: 0,
  class: "error"
}
const _hoisted_47 = { class: "field" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("label", { for: "email" }, [
  /*#__PURE__*/_createTextVNode("Email"),
  /*#__PURE__*/_createElementVNode("span", { class: "req" }, "*")
], -1)
const _hoisted_49 = {
  key: 0,
  class: "error"
}
const _hoisted_50 = { class: "field" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Blocked"),
  /*#__PURE__*/_createElementVNode("span", { class: "req" }, "*")
], -1)
const _hoisted_52 = { class: "formgrid grid" }
const _hoisted_53 = { class: "field-radiobutton col-12" }
const _hoisted_54 = { for: "status" }
const _hoisted_55 = { class: "data" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("strong", null, "Enterprise:", -1)
const _hoisted_57 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_58 = { class: "data" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("strong", null, "Enterprise ID:", -1)
const _hoisted_60 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_61 = { class: "data" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("strong", null, "Enterprise Store Name:", -1)
const _hoisted_63 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_64 = { class: "data" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("strong", null, "Enterprise Store ID:", -1)
const _hoisted_66 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_67 = { class: "data" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("strong", null, "Name:", -1)
const _hoisted_69 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_70 = { class: "data" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("strong", null, "Email:", -1)
const _hoisted_72 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_73 = { class: "data" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("strong", null, "Role:", -1)
const _hoisted_75 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_76 = { class: "data" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("strong", null, "Blocked?:", -1)
const _hoisted_78 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_79 = {
  key: 0,
  class: "p-button-rounded btn-blocked"
}
const _hoisted_80 = {
  key: 1,
  label: "No",
  class: "p-button-rounded btn-blocked"
}
const _hoisted_81 = { class: "field" }
const _hoisted_82 = /*#__PURE__*/_createElementVNode("label", { for: "password" }, [
  /*#__PURE__*/_createTextVNode("New password"),
  /*#__PURE__*/_createElementVNode("span", { class: "req" }, "*")
], -1)
const _hoisted_83 = {
  key: 0,
  class: "error"
}
const _hoisted_84 = { class: "field" }
const _hoisted_85 = /*#__PURE__*/_createElementVNode("label", { for: "confirmpassword" }, [
  /*#__PURE__*/_createTextVNode("Confirm password"),
  /*#__PURE__*/_createElementVNode("span", { class: "req" }, "*")
], -1)
const _hoisted_86 = {
  key: 0,
  class: "error"
}

import { ref, onBeforeMount, computed } from 'vue';
import { FilterMatchMode } from 'primevue/api';
import { useAuth0 } from "@auth0/auth0-vue";
import { useRouter } from 'vue-router';
import ErrorModal from './ErrorModal.vue';
import { openErrorModal } from '@/composables/useErrorLog';
import { required, minLength, sameAs, helpers } from '@vuelidate/validators';
import { useVuelidate } from '@vuelidate/core';
import { useToast } from 'primevue/usetoast';
import { useConfirm } from "primevue/useconfirm";
import { useStore } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  __name: 'EnterpriseUsers',
  setup(__props) {

const entstoreloading = ref(true);
const filters = ref({ 'global' : { value: null, matchMode: FilterMatchMode.CONTAINS } });
const loadingDT = ref(false);
const storeid = ref('');
const role = ref('');
const storestatus = ref('');
const router = useRouter();
const toast = useToast();
const users = ref();
const user = ref({ enterpriseid: '', storeid: '', storename: '', enterprisename: '', name: '', email: '', role: '', blocked: '', blockedbool: false, user_id: '' });
const enterprises = ref();
const enterprisestores = ref();
const createUserDialog = ref(false);
const viewUserDialog = ref(false);
const editUserDialog = ref(false);
const changePasswordDialog = ref(false);
const password = ref('');
const changePasswordFlag = ref(false);
const confirmpassword = ref('');
const rules = computed(() => ({
	password: { required: helpers.withMessage('Password cannot be empty', required), minLength: helpers.withMessage('Password must be at least 8 characters', minLength(8)), valid: helpers.withMessage('Password must contain uppercase, lowercase, number, special character', valid) },
	confirmpassword: { required: helpers.withMessage('Confirm password cannot be empty', required), sameAs: helpers.withMessage('Confirm password must be the same as New Password', sameAs(password)) },
}));

const rulesv = computed(() => ({
	enterpriseid: { required: helpers.withMessage('Enterprise cannot be empty.', required) },
	storeid: { required: helpers.withMessage('Enterprise store cannot be empty.', required) },
    name: { required: helpers.withMessage('Name cannot be empty.', required) },
    email: { required: helpers.withMessage('Email already exists in the system. Please use another.', required) },
}));

let vv$ = useVuelidate(rulesv, user);
let v$ = useVuelidate(rules, { password, confirmpassword });
const searchtext = ref('');
const confirm = useConfirm();
const auth0 = useAuth0();
const editInitialValue = ref();
let initialValues = {
  email: '',
  password: ''
};
const searchinitialValue = ref('');

onBeforeMount(async () => {
	loadingDT.value = true;
	const store = useStore();
	const auth0 = useAuth0();
	const accessToken = await auth0.getAccessTokenSilently();
	storeid.value = store.state.storeid;
	role.value = store.state.role;
	storestatus.value = store.state.storestatus;

	if (storestatus.value == 'Disable' || role.value != 'SupportAdmin') {
		router.push('/storedisable');
	}

	if (role.value === 'SupportAdmin') {
		await getAllEnterprises(accessToken);
		await getAllEnterpriseUsers(accessToken);
		loadingDT.value = false;
	}
});

const handleInputChange = (field) => {
	if (field === 'email') {
		initialValues.email = user.value.email;
	} else if (field === 'password') {
		initialValues.password = password.value;
	}
}

const handleFocus = (field) => {
	setTimeout(() => {
		if (field === 'email' && user.value.email === initialValues.email) {
			if (createUserDialog.value === true || changePasswordDialog.value === true) {
				user.value.email = '';
			}
		} else if (field === 'password' && password.value === initialValues.password) {
			if (createUserDialog.value === true || changePasswordDialog.value === true) {
				password.value = '';
			}
		}
	}, 0);
};

const getEnterpriseStores = async () => {
	try {
		entstoreloading.value = true;
		const accessToken = await auth0.getAccessTokenSilently();
		const response = await fetch(process.env.VUE_APP_NODEJS_BASE_URL + "sa/enterprises/stores/" + user.value.enterpriseid, {
			headers: {
				Authorization: `Bearer ${accessToken}`,
			}
		});
		const data = await response.json();
		if (response.status > 400) {
			throw new Error(JSON.stringify(data.error));
		}
		enterprisestores.value = data.message;
		entstoreloading.value = false;
	} catch (e) {
		openErrorModal(e.message);
	}
}

const getAllEnterprises = async (accessToken: string) => {
	try {
		const response = await fetch(process.env.VUE_APP_NODEJS_BASE_URL + "sa/enterprises", {
			headers: {
				Authorization: `Bearer ${accessToken}`,
			}
		});
		const data = await response.json();
		if (response.status > 400) {
			throw new Error(JSON.stringify(data.error));
		}
		enterprises.value = data.message;
		sortByEnterpriseName();
	} catch (e) {
		openErrorModal(e.message);
	}
}

const sortByEnterpriseName = () => {
	enterprises.value.sort((a, b) => {
		if (!a.EnterpriseName || !b.EnterpriseName) {
			throw new Error("Missing 'EnterpriseName' field for one or more objects in the array.");
		}
		
		return a.EnterpriseName.localeCompare(b.EnterpriseName);
	});
}

const getAllEnterpriseUsers = async (accessToken) => {
	try {
		const response = await fetch(process.env.VUE_APP_NODEJS_BASE_URL + "sa/enterprises/users", {
			headers: {
				Authorization: `Bearer ${accessToken}`,
			}
		});
		const data = await response.json();
		if (response.status > 400) {
			throw new Error(JSON.stringify(data.error));
		}

		users.value = data.message;
		users.value.map((userItem) => {
			const { EnterpriseName } = enterprises.value.find(item => item.EnterpriseId === userItem.enterpriseid);
			userItem.enterprisename = EnterpriseName;
		});
	} catch (e) {
		openErrorModal(e.message);
	}
}

const openCreateDialog = () => {
    createUserDialog.value = true;
	user.value = { enterpriseid: '', storeid: '', storename: '', enterprisename: '', user_id: '', name: '', email: '', role: '', blocked: '', blockedbool: false };
    password.value = '';
    confirmpassword.value = '';
	vv$ = useVuelidate(rulesv, user);
    v$ = useVuelidate(rules, { password, confirmpassword });
}

/**
 * Initialize filter
 */
function clearFilter() {
	filters.value = {
		'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
	};
}

const viewUser = async (userDetail) => {
	viewUserDialog.value = true;
	user.value = userDetail;
	await getEnterpriseStores();
	const index = enterprisestores.value.findIndex(item => item.StoreId === user.value.storeid);
	if (index >= 0) {
		user.value.storeid = enterprisestores.value[index].StoreId;
		user.value.storename = enterprisestores.value[index].StoreName;
	}
}

const editUser = async (userDetail) => {
	user.value = userDetail;
	user.value.blockedbool = user.value.blocked === 'true';
    editUserDialog.value = true;
	editInitialValue.value = JSON.parse(JSON.stringify(userDetail));
	await getEnterpriseStores();
}

const saveUser = async () => {
    if (!await vv$.value.$validate()) return;
    if (!await v$.value.$validate()) return;
    try {
        let userdata = {
            name: user.value.name,
            email: user.value.email,
            blocked: user.value.blockedbool ? "true" : "false",
            password: password.value,
			enterpriseid: user.value.enterpriseid,
			storeid: user.value.storeid
        };
        const accessToken = await auth0.getAccessTokenSilently();
        const response = await fetch(process.env.VUE_APP_NODEJS_BASE_URL + "sa/enterprises/users", {
            method: 'POST',
            body: JSON.stringify(userdata),
            headers: {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json'
            },
        });
        const data = await response.json();
        if (response.status > 400) {
			if (data.error.message === 'Request failed with status code 409') {
				return toast.add({ severity: 'error', summary: 'Error', detail: 'The user already exists.', life: 3000 });
			}
            throw new Error(JSON.stringify(data.error));
        }
        user.value.blocked = user.value.blockedbool ? "true" : "false";
        user.value.role = 'EnterpriseAdmin';
		const { EnterpriseName } = enterprises.value.find(item => item.EnterpriseId === user.value.enterpriseid);
		user.value.enterprisename = EnterpriseName;
        users.value.push(user.value);
        user.value.user_id = data.message.result;
        
        createUserDialog.value = false;
        password.value = '';
        confirmpassword.value = '';
		user.value = { enterpriseid: '', storeid: '', storename: '', enterprisename: '', user_id: '', name: '', email: '', role: '', blocked: '', blockedbool: false };
		entstoreloading.value = true;
		enterprisestores.value = [];

		vv$.value.$reset();
		v$.value.$reset();
        toast.add({ severity: 'success', summary: 'Successful', detail: 'User has been created successfully.', life: 3000 });
    } catch (e) {
        openErrorModal(e.message);
        toast.add({ severity: 'error', summary: 'Error', detail: 'Create enterprise user failed.', life: 3000 });
    }
}

const updateUser = async () => {
	if (!await vv$.value.$validate()) return;
	try {
        let userdata = {
            name: user.value.name,
            email: user.value.email,
            blocked: user.value.blockedbool ? "true" : "false",
			enterpriseid: user.value.enterpriseid,
			storeid: user.value.storeid
        };
        const accessToken = await auth0.getAccessTokenSilently();
        const response = await fetch(process.env.VUE_APP_NODEJS_BASE_URL + "sa/enterprises/users/" + user.value.user_id, {
            method: 'PATCH',
            body: JSON.stringify(userdata),
            headers: {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json'
            },
        });
        const data = await response.json();
        if (response.status > 400) {
            throw new Error(JSON.stringify(data.error));
        }
		const { EnterpriseName } = enterprises.value.find(item => item.EnterpriseId === user.value.enterpriseid);
		user.value.enterprisename = EnterpriseName;
        user.value.blocked = user.value.blockedbool ? "true" : "false";
        editUserDialog.value = false;
		user.value = { enterpriseid: '', storeid: '', storename: '', enterprisename: '', user_id: '', name: '', email: '', role: '', blocked: '', blockedbool: false };

		vv$.value.$reset();
		v$.value.$reset();
        toast.add({ severity: 'success', summary: 'Successful', detail: 'User details have been updated successfully.', life: 3000 });
    } catch (e) {
        openErrorModal(e.message);
        toast.add({ severity: 'error', summary: 'Error', detail: 'Update enterprise user failed.', life: 3000 });
    }
}

const deleteUser = async () => {
    confirm.require({
		message: 'Do you want to delete the current user?',
		header: 'Please confirm deletion',
		icon: 'pi pi-exclamation-triangle',
		acceptClass: 'p-button-danger',
		accept: async () => {
			const url = process.env.VUE_APP_NODEJS_BASE_URL + "sa/enterprises/users/" + user.value.user_id;
			try {
				const accessToken = await auth0.getAccessTokenSilently();
				const response = await fetch(url, {
					method: 'DELETE',
					headers: {
						Authorization: `Bearer ${accessToken}`,
						'Content-Type': 'application/json'
					},
				});
				//then delete user from array objects
				if (response.status >= 200 && response.status < 300) {
					for (var i = 0; i < users.value.length; i++) {
						if (users.value[i].user_id === user.value.user_id) {
							users.value.splice(i, 1);
							i--;
						}
					}
					toast.add({ severity: 'error', summary: 'Confirmed', detail: 'User has been deleted successfully.', life: 3000 });
				}				
				const data = await response.json();
				if (response.status > 400) {
					throw new Error(JSON.stringify(data.error));
				}
			} catch (e) {
				openErrorModal(e.message);
			}
		},
		reject: () => {
			toast.add({ severity: 'error', summary: 'Rejected', detail: 'User deletion cancelled.', life: 3000 });
		}
	});
	editUserDialog.value = false;
}

const savePassword = async () => {
	if (!await v$.value.$validate()) return;
	try {
        let userdata = {
            password: password.value
        };
        const accessToken = await auth0.getAccessTokenSilently();
        const response = await fetch(process.env.VUE_APP_NODEJS_BASE_URL + "sa/enterprises/users/" + user.value.user_id, {
            method: 'PATCH',
            body: JSON.stringify(userdata),
            headers: {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
				'Update': 'Change-Password'
            },
        });
        const data = await response.json();
        if (response.status > 400) {
            throw new Error(JSON.stringify(data.error));
        }
        user.value.blocked = user.value.blockedbool ? "true" : "false";
		password.value = '';
		confirmpassword.value = '';
        changePasswordDialog.value = false;
		user.value = { enterpriseid: '', storeid: '', storename: '', enterprisename: '', user_id: '', name: '', email: '', role: '', blocked: '', blockedbool: false };

        toast.add({ severity: 'success', summary: 'Successful', detail: 'Password has been updated successfully.', life: 3000 });
		changePasswordFlag.value = true;
    } catch (e) {
        openErrorModal(e.message);
        toast.add({ severity: 'error', summary: 'Error', detail: 'Password update failed.', life: 3000 });
    }
}

const hideEditDialog = () => {
	const userIndex = users.value.findIndex(item => item.email == editInitialValue.value.email);
	users.value[userIndex] = editInitialValue.value;
    createUserDialog.value = false;
	viewUserDialog.value = false;
	editUserDialog.value = false;
	changePasswordDialog.value = false;
}

const changeUserPassword = (userDetail) => {
	user.value = { enterpriseid: '', storeid: '', storename: '', enterprisename: '', user_id: '', name: '', email: '', role: '', blocked: '', blockedbool: false };
	password.value = '';
	confirmpassword.value = '';
    changePasswordDialog.value = true;
	user.value = userDetail;
	v$.value.$reset();
}

const blockunblockUser = async (userDetail) => {
	try {
		user.value = userDetail;
        let userdata = {
            blocked: user.value.blocked
        };
        const accessToken = await auth0.getAccessTokenSilently();
        const response = await fetch(process.env.VUE_APP_NODEJS_BASE_URL + "sa/enterprises/users/" + user.value.user_id, {
            method: 'PATCH',
            body: JSON.stringify(userdata),
            headers: {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
				'Update': 'blockunblock'
            },
        });
        const data = await response.json();
        if (response.status > 400) {
            throw new Error(JSON.stringify(data.error));
        }
        user.value.blocked = user.value.blocked == 'true' ? "false" : "true";
		vv$.value.$reset();
		v$.value.$reset();
        toast.add({ severity: 'success', summary: 'Successful', detail: 'User status has been updated successfully.', life: 3000 });
    } catch (e) {
        openErrorModal(e.message);
        toast.add({ severity: 'error', summary: 'Error', detail: 'User status update failed.', life: 3000 });
    }
}

function valid(value: string) {
	const containsUppercase = /[A-Z]/.test(value);
	const containsLowercase = /[a-z]/.test(value);
	const containsNumber = /[0-9]/.test(value);
	const containsSpecial = /[#?!@$%^&*-]/.test(value);
	return containsUppercase && containsLowercase && containsNumber && containsSpecial;
}

const handleInputSearch = (event) => {
	if (changePasswordFlag.value == true) {
		setTimeout(() => { clearFilter(); changePasswordFlag.value = false;}, 0);
		return ;
	}
	searchinitialValue.value = event.target.value;
	searchtext.value = event.target.value;
	if (changePasswordDialog.value == true) {
		clearFilter();
		event.target.value = '';
		searchtext.value = '';
	} else {
		if (searchtext.value == '') {
			clearFilter();
			event.target.value = '';
			searchtext.value = '';
		}
		else {
			clearFilter();
			event.target.value = '';
			filters.value.global.value = searchtext.value;
		}
	}
}

const handleFocusSearch = () => {
    if (changePasswordFlag.value === true) {
        setTimeout(() => {
            clearFilter();
            changePasswordFlag.value = false;
        }, 0);
        return;
    }
    setTimeout(() => {
        if (searchtext.value === searchinitialValue.value) {
            searchtext.value = '';
        }
    }, 0);
};

const cancelSaveUser = () => {
	createUserDialog.value = false;
	entstoreloading.value = true;
	enterprisestores.value = [];
}

return (_ctx: any,_cache: any) => {
  const _component_Toast = _resolveComponent("Toast")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Password = _resolveComponent("Password")!
  const _component_InputSwitch = _resolveComponent("InputSwitch")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ErrorModal),
    _createVNode(_component_Toast),
    _createVNode(_component_ConfirmDialog),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_InputText, {
              id: "search",
              name: "search",
              modelValue: filters.value['global'].value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.value['global'].value) = $event)),
              placeholder: "Search",
              onFocus: handleFocusSearch,
              onInput: handleInputSearch
            }, null, 8, ["modelValue"]),
            _createVNode(_component_Button, {
              type: "button",
              icon: "pi pi-times",
              class: "p-button-text clear",
              onClick: clearFilter
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("span", _hoisted_9, [
            _hoisted_10,
            _createVNode(_component_InputText, {
              id: "search",
              name: "search",
              modelValue: filters.value['global'].value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.value['global'].value) = $event)),
              placeholder: "Search",
              onFocus: handleFocusSearch,
              onInput: handleInputSearch
            }, null, 8, ["modelValue"]),
            _createVNode(_component_Button, {
              type: "button",
              icon: "pi pi-times",
              class: "p-button-text clear",
              onClick: clearFilter
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_Button, {
            label: "Create User",
            class: "p-button-rounded btn-create btn-primary",
            onClick: openCreateDialog
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createVNode(_component_DataTable, {
        class: "managerclient-data-table",
        ref: "dt",
        loading: loadingDT.value,
        value: users.value,
        dataKey: "id",
        paginator: true,
        rows: 10,
        filters: filters.value,
        stripedRows: "",
        responsiveLayout: "stack",
        breakpoint: "800px",
        paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
        rowsPerPageOptions: [5, 10, 25],
        currentPageReportTemplate: "Showing {first} to {last} of {totalRecords} users"
      }, {
        empty: _withCtx(() => [
          _hoisted_14
        ]),
        default: _withCtx(() => [
          _createVNode(_component_Column, {
            field: "name",
            class: "name",
            header: "Name",
            sortable: true
          }),
          _createVNode(_component_Column, {
            field: "email",
            class: "email",
            header: "Email",
            sortable: true
          }),
          _createVNode(_component_Column, {
            field: "enterprisename",
            class: "name",
            header: "Enterprise",
            sortable: true
          }),
          _createVNode(_component_Column, {
            field: "blocked",
            class: "status",
            header: "Blocked?",
            sortable: true
          }, {
            body: _withCtx((slotProps) => [
              (slotProps.data.blocked == 'true')
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    label: "Yes",
                    class: _normalizeClass(["p-button-rounded p-button-danger blocked", slotProps.data.blocked]),
                    onClick: ($event: any) => (blockunblockUser(slotProps.data))
                  }, null, 8, ["class", "onClick"]))
                : (_openBlock(), _createBlock(_component_Button, {
                    key: 1,
                    label: "No",
                    class: _normalizeClass(["p-button-rounded p-button-success blocked", slotProps.data.blocked]),
                    onClick: ($event: any) => (blockunblockUser(slotProps.data))
                  }, null, 8, ["class", "onClick"]))
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "view",
            class: "view",
            header: " ",
            sortable: false
          }, {
            body: _withCtx((slotProps) => [
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_Button, {
                  label: "View",
                  class: "p-button-rounded btn-view btn-secondary",
                  onClick: ($event: any) => (viewUser(slotProps.data))
                }, null, 8, ["onClick"]),
                _createVNode(_component_Button, {
                  label: "Edit",
                  class: "p-button-rounded btn-edit btn-secondary",
                  onClick: ($event: any) => (editUser(slotProps.data))
                }, null, 8, ["onClick"]),
                _createVNode(_component_Button, {
                  label: "Change Password",
                  class: "p-button-rounded btn-password btn-primary",
                  onClick: ($event: any) => (changeUserPassword(slotProps.data))
                }, null, 8, ["onClick"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["loading", "value", "filters"]),
      _createVNode(_component_Dialog, {
        visible: createUserDialog.value,
        "onUpdate:visible": _cache[14] || (_cache[14] = ($event: any) => ((createUserDialog).value = $event)),
        header: "Create EnterpriseUser Admin",
        modal: true,
        class: "p-fluid",
        onHide: _cache[15] || (_cache[15] = ($event: any) => (cancelSaveUser()))
      }, {
        footer: _withCtx(() => [
          _createVNode(_component_Button, {
            label: "Cancel",
            class: "p-button-rounded btn-cancel btn-secondary",
            onClick: _cache[13] || (_cache[13] = ($event: any) => (createUserDialog.value = false))
          }),
          _createVNode(_component_Button, {
            label: "Save",
            class: "p-button-rounded btn-save btn-primary",
            onClick: saveUser
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createVNode(_component_Dropdown, {
              modelValue: user.value.enterpriseid,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((user.value.enterpriseid) = $event)),
              filter: "",
              options: enterprises.value,
              optionLabel: "EnterpriseName",
              optionValue: "EnterpriseId",
              placeholder: "Select an enterprise",
              required: "true",
              onChange: getEnterpriseStores
            }, null, 8, ["modelValue", "options"]),
            (_unref(vv$).enterpriseid.$error)
              ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_unref(vv$).enterpriseid.$errors[0].$message), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createVNode(_component_Dropdown, {
              disabled: entstoreloading.value,
              modelValue: user.value.storeid,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((user.value.storeid) = $event)),
              filter: "",
              options: enterprisestores.value,
              optionLabel: "StoreName",
              optionValue: "StoreId",
              placeholder: "Select an enterprise store",
              required: "true"
            }, null, 8, ["disabled", "modelValue", "options"]),
            (_unref(vv$).storeid.$error)
              ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_unref(vv$).storeid.$errors[0].$message), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _createVNode(_component_InputText, {
              id: "name",
              modelValue: user.value.name,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((user.value.name) = $event)),
              modelModifiers: { trim: true },
              required: "true"
            }, null, 8, ["modelValue"]),
            (_unref(vv$).name.$error)
              ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_unref(vv$).name.$errors[0].$message), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_24, [
            _hoisted_25,
            _createVNode(_component_InputText, {
              id: "email",
              modelValue: user.value.email,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((user.value.email) = $event)),
              modelModifiers: { trim: true },
              required: "true",
              onFocus: _cache[6] || (_cache[6] = ($event: any) => (handleFocus('email'))),
              onInput: _cache[7] || (_cache[7] = ($event: any) => (handleInputChange('email')))
            }, null, 8, ["modelValue"]),
            (_unref(vv$).email.$error)
              ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_unref(vv$).email.$errors[0].$message), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_27, [
            _hoisted_28,
            _createVNode(_component_InputText, {
              type: "password",
              id: "password",
              modelValue: password.value,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((password).value = $event)),
              modelModifiers: { trim: true },
              required: "",
              onFocus: _cache[9] || (_cache[9] = ($event: any) => (handleFocus('password'))),
              onInput: _cache[10] || (_cache[10] = ($event: any) => (handleInputChange('password')))
            }, null, 8, ["modelValue"]),
            (_unref(v$).password.$error)
              ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(_unref(v$).password.$errors[0].$message), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_30, [
            _hoisted_31,
            _createVNode(_component_Password, {
              id: "confirmpassword",
              modelValue: confirmpassword.value,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((confirmpassword).value = $event)),
              modelModifiers: { trim: true },
              required: ""
            }, null, 8, ["modelValue"]),
            (_unref(v$).confirmpassword.$error)
              ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(_unref(v$).confirmpassword.$errors[0].$message), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_33, [
            _hoisted_34,
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _createVNode(_component_InputSwitch, {
                  modelValue: user.value.blockedbool,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((user.value.blockedbool) = $event)),
                  style: {"border-radius":"1.5em"}
                }, null, 8, ["modelValue"]),
                _createElementVNode("label", _hoisted_37, _toDisplayString(user.value.blockedbool ? 'Yes' : 'No'), 1)
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_component_Dialog, {
        visible: editUserDialog.value,
        "onUpdate:visible": _cache[21] || (_cache[21] = ($event: any) => ((editUserDialog).value = $event)),
        header: "Update EnterpriseUser Admin",
        modal: true,
        class: "p-fluid",
        onHide: _cache[22] || (_cache[22] = ($event: any) => (cancelSaveUser()))
      }, {
        footer: _withCtx(() => [
          _createVNode(_component_Button, {
            label: "Cancel",
            class: "p-button-rounded btn-cancel btn-secondary",
            onClick: hideEditDialog
          }),
          _createVNode(_component_Button, {
            label: "Delete",
            class: "p-button-rounded btn-save btn-danger",
            onClick: deleteUser
          }),
          _createVNode(_component_Button, {
            label: "Save",
            class: "p-button-rounded btn-save btn-primary",
            onClick: updateUser
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_38, [
            _hoisted_39,
            _createVNode(_component_Dropdown, {
              modelValue: user.value.enterpriseid,
              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((user.value.enterpriseid) = $event)),
              filter: "",
              options: enterprises.value,
              optionLabel: "EnterpriseName",
              optionValue: "EnterpriseId",
              placeholder: "Select an enterprise",
              required: "true",
              onChange: getEnterpriseStores
            }, null, 8, ["modelValue", "options"]),
            (_unref(vv$).enterpriseid.$error)
              ? (_openBlock(), _createElementBlock("span", _hoisted_40, _toDisplayString(_unref(vv$).enterpriseid.$errors[0].$message), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_41, [
            _hoisted_42,
            _createVNode(_component_Dropdown, {
              disabled: entstoreloading.value,
              modelValue: user.value.storeid,
              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((user.value.storeid) = $event)),
              filter: "",
              options: enterprisestores.value,
              optionLabel: "StoreName",
              optionValue: "StoreId",
              placeholder: "Select an enterprise store",
              required: "true"
            }, null, 8, ["disabled", "modelValue", "options"]),
            (_unref(vv$).storeid.$error)
              ? (_openBlock(), _createElementBlock("span", _hoisted_43, _toDisplayString(_unref(vv$).storeid.$errors[0].$message), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_44, [
            _hoisted_45,
            _createVNode(_component_InputText, {
              id: "name",
              modelValue: user.value.name,
              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((user.value.name) = $event)),
              modelModifiers: { trim: true },
              required: "true"
            }, null, 8, ["modelValue"]),
            (_unref(vv$).name.$error)
              ? (_openBlock(), _createElementBlock("span", _hoisted_46, _toDisplayString(_unref(vv$).name.$errors[0].$message), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_47, [
            _hoisted_48,
            _createVNode(_component_InputText, {
              id: "email",
              modelValue: user.value.email,
              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((user.value.email) = $event)),
              modelModifiers: { trim: true },
              required: "true"
            }, null, 8, ["modelValue"]),
            (_unref(vv$).email.$error)
              ? (_openBlock(), _createElementBlock("span", _hoisted_49, _toDisplayString(_unref(vv$).email.$errors[0].$message), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_50, [
            _hoisted_51,
            _createElementVNode("div", _hoisted_52, [
              _createElementVNode("div", _hoisted_53, [
                _createVNode(_component_InputSwitch, {
                  modelValue: user.value.blockedbool,
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((user.value.blockedbool) = $event)),
                  style: {"border-radius":"1.5em"}
                }, null, 8, ["modelValue"]),
                _createElementVNode("label", _hoisted_54, _toDisplayString(user.value.blockedbool ? 'Yes' : 'No'), 1)
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_component_Dialog, {
        visible: viewUserDialog.value,
        "onUpdate:visible": _cache[24] || (_cache[24] = ($event: any) => ((viewUserDialog).value = $event)),
        header: "View EnterpriseAdmin User Details",
        modal: true,
        class: "p-fluid",
        onHide: _cache[25] || (_cache[25] = ($event: any) => (cancelSaveUser()))
      }, {
        footer: _withCtx(() => [
          _createVNode(_component_Button, {
            label: "Cancel",
            class: "p-button-rounded btn-cancel btn-secondary",
            onClick: _cache[23] || (_cache[23] = ($event: any) => (viewUserDialog.value = false))
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_55, [
            _createElementVNode("p", null, [
              _hoisted_56,
              _hoisted_57,
              _createElementVNode("span", null, _toDisplayString(user.value.enterprisename), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_58, [
            _createElementVNode("p", null, [
              _hoisted_59,
              _hoisted_60,
              _createElementVNode("span", null, _toDisplayString(user.value.enterpriseid), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_61, [
            _createElementVNode("p", null, [
              _hoisted_62,
              _hoisted_63,
              _createElementVNode("span", null, _toDisplayString(user.value.storename), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_64, [
            _createElementVNode("p", null, [
              _hoisted_65,
              _hoisted_66,
              _createElementVNode("span", null, _toDisplayString(user.value.storeid), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_67, [
            _createElementVNode("p", null, [
              _hoisted_68,
              _hoisted_69,
              _createElementVNode("span", null, _toDisplayString(user.value.name), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_70, [
            _createElementVNode("p", null, [
              _hoisted_71,
              _hoisted_72,
              _createElementVNode("span", null, _toDisplayString(user.value.email), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_73, [
            _createElementVNode("p", null, [
              _hoisted_74,
              _hoisted_75,
              _createElementVNode("span", null, _toDisplayString(user.value.role), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_76, [
            _createElementVNode("p", null, [
              _hoisted_77,
              _hoisted_78,
              (user.value.blocked == 'true')
                ? (_openBlock(), _createElementBlock("span", _hoisted_79, "Yes"))
                : (_openBlock(), _createElementBlock("span", _hoisted_80, "No"))
            ])
          ])
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_component_Dialog, {
        visible: changePasswordDialog.value,
        "onUpdate:visible": _cache[31] || (_cache[31] = ($event: any) => ((changePasswordDialog).value = $event)),
        header: "Change password",
        modal: true,
        class: "p-fluid"
      }, {
        footer: _withCtx(() => [
          _createVNode(_component_Button, {
            label: "Cancel",
            class: "p-button-rounded btn-cancel btn-secondary",
            onClick: _cache[30] || (_cache[30] = ($event: any) => (changePasswordDialog.value = false))
          }),
          _createVNode(_component_Button, {
            label: "Save",
            class: "p-button-rounded btn-save btn-primary",
            onClick: savePassword
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_81, [
            _hoisted_82,
            _createVNode(_component_Password, {
              id: "password",
              modelValue: password.value,
              "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((password).value = $event)),
              modelModifiers: { trim: true },
              required: "",
              onFocus: _cache[27] || (_cache[27] = ($event: any) => (handleFocus('password'))),
              onInput: _cache[28] || (_cache[28] = ($event: any) => (handleInputChange('password')))
            }, null, 8, ["modelValue"]),
            (_unref(v$).password.$error)
              ? (_openBlock(), _createElementBlock("span", _hoisted_83, _toDisplayString(_unref(v$).password.$errors[0].$message), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_84, [
            _hoisted_85,
            _createVNode(_component_Password, {
              id: "confirmpassword",
              modelValue: confirmpassword.value,
              "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((confirmpassword).value = $event)),
              modelModifiers: { trim: true },
              required: ""
            }, null, 8, ["modelValue"]),
            (_unref(v$).confirmpassword.$error)
              ? (_openBlock(), _createElementBlock("span", _hoisted_86, _toDisplayString(_unref(v$).confirmpassword.$errors[0].$message), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["visible"])
    ])
  ], 64))
}
}

})